<div cdkTrapFocus [cdkTrapFocusAutoCapture]="true">
	<modal-header-default class="border"> </modal-header-default>
	<div class="info-holder">
		<div class="success-icon">
			<img class="end-screen-img" src="/assets/images/success.svg" />
		</div>

		<h1>{{ "web3_success_heading" | translate: [successSignal.tradable.getAssetSymbol()] }} </h1>

		@if (successSignal?.amount) {
			<p>
				{{
					"web3_success_description"
						| translate
							: [
									successSignal.amount
										| tradable_precision_symbol
											: {
													id: successSignal.tradable?.getId(),
													ignorePrecision: false
											  }
							  ]
				}}</p
			>
		}
	</div>

	<div class="button-holder">
		<button (click)="seeMore()" class="btn next-btn text-btn">{{ "web3_success_link" | translate }}</button>
		@if (showStaking$ | async; as showStakingLabel) {
			<button (click)="next()" class="btn btn-primary next-btn">
				{{ "web3_success_cta" | translate: [showStakingLabel] }}</button
			>
		}
	</div>
</div>
